import React from 'react'

export const HomeMobile = () => {
  return <div className="text-3xl font-bold underline">Hello</div>
}
